import {HttpStatusCode} from "axios";
import LoggedUserContext from "../model/auth/LoggedUserContext";
import PageInfoRequest from "../model/common/PageInfoRequest";
import CallDTO from "../model/dto/CallDTO";
import CallsFilters from "../model/filters/CallsFilters";
import http from '../utils/HttpCommon';

const getAll = async (context: LoggedUserContext, pageInfo: PageInfoRequest) => {
	try {
		const response = await http.privateClient(context).get<any>('/calls/search/findAllNotDeleted', { params: pageInfo });

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response ? e.response.status : undefined, undefined];
	}
}

const getAllInterested = async (context: LoggedUserContext, id: string) => {
	try {
		const response = await http.privateClient(context).get<any>(`/calls/${id}/users`);

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response ? e.response.status : undefined, undefined];
	}
}

const getAllFiltered = async (context: LoggedUserContext, pageInfo: PageInfoRequest, filters: CallsFilters) => {
	try {
		let params: any = {
			...pageInfo
		};
		Object.entries(filters).forEach(([key, lblValue]) => {
			params[key] = lblValue.value;
		});

		const response = await http.privateClient(context).get<any>('/calls/search/findAllByFilters', { params });

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response ? e.response.status : undefined, undefined];
	}
}

const save = async (context: LoggedUserContext, call: CallDTO) => {
	try {
		const response = await http.privateClient(context).post<any>('/calls', {...call, state: 'ACTIVE'});

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response ? e.response.status : undefined, undefined];
	}
}

const update = async (context: LoggedUserContext, call: CallDTO, id: string) => {
	try {
		const response = await http.privateClient(context).put<any>(`/calls/${id}`, call);

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response ? e.response.status : undefined, undefined];
	}
}

const deleteById = async (context: LoggedUserContext, id: string) => {
	try {
		const response = await http.privateClient(context).delete<any>(`/products/${id}`);

		if (response && response.status === HttpStatusCode.Ok) {
			context.setNeedRefreshSidebar?.(true);
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response ? e.response.status : undefined, undefined];
	}
}

const changeStateById = async (context: LoggedUserContext, id: string, state: string) => {
	try {
		const response = await http.privateClient(context).put<any>(`/calls/${id}/state/${state}`);

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response ? e.response.status : undefined, undefined];
	}
}

const changeInterestById = async (context: LoggedUserContext, id: string, state: boolean) => {
	try {
		const response = await http.privateClient(context).put<any>(`/calls/${id}/user/${context.user?.id}/interest/${state}`);

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response ? e.response.status : undefined, undefined];
	}
}

const evaluate = async (context: LoggedUserContext, id: string, body: {
    partitaIva?: string;
    cittaSedi?: string[];
    numeroDipendenti?: number;
    codiciAteco?: string[];
    fatturatoUltimi3Bilanci?: number[];
}) => {
    try {
        const response = await http.privateClient(context).post<any>(`/calls/${id}/evaluate`, body);
        if (response && response.status === HttpStatusCode.Ok) {
            return [response.status, response.data];
        }
        return [response ? response.status : undefined, undefined];
    } catch (e: any) {
        console.error(e);
        return [e.response ? e.response.status : undefined, undefined];
    }
}

const deleteAll = async (context: LoggedUserContext) => { }
const exportSelected = async (context: LoggedUserContext) => { }

const CallService = {
	getAll,
	getAllFiltered,
	save,
	update,
	changeStateById,
	deleteById,
	changeInterestById,
	deleteAll,
	exportSelected,
    getAllInterested,
    evaluate
}

export default CallService;